// extracted by mini-css-extract-plugin
export var fadeIn = "_mv-1";
export var modalContent = "_mv-3";
export var overlay = "_mv-0";
export var popoverContent = "_mv-2";
export var results = "_mv-5";
export var searchInputWrapper = "_mv-4";